<template lang="pug">

  a.logout-button-component(v-if="authenticated", :href="redirect", @click="logout")
    slot

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'logout-button',

  props: ['redirect'],

  computed: mapGetters({
    authenticated: 'authCheck'
  }),

  methods: {
    async logout () {
      await this.$store.dispatch('logout')
      // this.$router.push({ name: 'sign-in' })
    }
  }
}
</script>
